import CircularProgress from "@mui/material/CircularProgress";

type LoadingProps = {
  partial?: boolean;
  opacity?: number;
};
const Loading = ({ partial, opacity }: LoadingProps) => {
  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center overflow-hidden"
      style={{
        opacity: opacity ?? 1,
        backgroundColor: partial ? "rgb(0,0,0,0)" : "white",
        zIndex: 2499,
      }}
    >
      <CircularProgress color="secondary" disableShrink size={100} />
    </div>
  );
};

export default Loading;
